import { useState, useMemo, FC } from 'react';
import { Box, Slider } from '@mui/material';
import { Document, Page } from 'react-pdf';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Loader } from 'shared/ui/Loader';
import { FileNavigation } from 'widgets/editFile/FileNavigation';
import { useFileEditorStore } from 'store/file-editor';
import styles from 'widgets/editFile/FilePreview/file.module.scss';

const DocumentViewer: FC = () => {
	const { fileDetails } = useFileEditorStore();
	const [totalFilePages, setTotalFilePages] = useState<number>();
	const [zoomDocValue, setZoomDocValue] = useState(0.7);
	const [currentFilePage, setCurrentFilePage] = useState(1);

	const navigationPages = useMemo(
		() => (totalFilePages ? Array.from({ length: totalFilePages }, (_, i) => i + 1) : []),
		[totalFilePages],
	);

	const handleScaleChangeSlider = (event: Event, value: number | number[]) => {
		setZoomDocValue(value as number);
	};

	return (
		<>
			<Document
				file={`${fileDetails?.host}/${fileDetails?.convertedFilePath}`}
				onLoadSuccess={({ numPages }) => setTotalFilePages(numPages)}
				className={styles.react_pdf_document}
				loading={<Loader width="70vw" height="85vh" />}
			>
				<FileNavigation
					navigationPages={navigationPages}
					currentFilePage={currentFilePage}
					changeCurrentFilePage={(page) => setCurrentFilePage(page)}
				/>

				<Box
					sx={{
						border: `2px solid ${ColorPalette.periwinkle}`,
						borderRadius: '20px',
						overflow: 'auto',
						height: '85vh',
						width: '100vw',
						textAlign: 'center',
						backgroundColor: '#f0f0f0',
					}}
				>
					<Page
						pageNumber={currentFilePage}
						scale={zoomDocValue}
						className={styles.react_pdf_pages}
					/>
				</Box>
			</Document>
			<Slider
				max={2}
				min={1}
				step={0.1}
				sx={{
					width: '40%',
					margin: '20px auto 0',
				}}
				onChange={handleScaleChangeSlider}
			/>
		</>
	);
};

export default DocumentViewer;
